import { useTranslation } from 'react-i18next'
import HelpTooltipIcon from '../../../../components/HelpTooltipIcon'
import { formatAverage, formatThousands } from '../../../../utils/formatNumber'
import BasicWidget from '../../Stats/components/widgets/BasicWidget'
import { useCountersAnalyticsData } from '../../analytics/hooks/use-counters-analytics-data'

const BeatBoxSwipesWidget = () => {
  const { t } = useTranslation()
  const { headlineStats, isLoading, locationRows } = useCountersAnalyticsData()
  const topLocation = locationRows[0]
  const locationCount = locationRows.length

  return (
    <BasicWidget
      title={`${formatThousands(topLocation?.swipes)} visits`}
      subtitle={t('stats.highestSwipedBeatBox')}
      iconRight={
        <HelpTooltipIcon text={t('stats.tooltips.highestSwipedBeatBox')} />
      }
      chipLabel={t('stats.averageSwipesPerBeatBox', {
        number: formatAverage(
          locationCount ? headlineStats.totalSwipes / locationCount : 0
        ),
      })}
      isLoading={isLoading}
    />
  )
}

export default BeatBoxSwipesWidget
